module.exports = __webpack_public_path__ + "img/iphone.773733a1.png";